export const USER_TIMING_EVENT_NAME = 'emb-user-timing';

export const KEY_EMB_USER_TIMING_NAME = 'emb.user_timing.name';
export const KEY_EMB_USER_TIMING_START_TIME = 'emb.user_timing.start_time';
export const KEY_EMB_USER_TIMING_DURATION = 'emb.user_timing.duration';
export const KEY_EMB_USER_TIMING_ENTRY_TYPE = 'emb.user_timing.entry_type';
export const KEY_EMB_USER_TIMING_DETAIL = 'emb.user_timing.detail';
